import React from 'react';
import PropTypes from 'prop-types';
import { InlineWidget } from 'react-calendly';

export default function CalendlyInline({ link }) {
  return (
    <InlineWidget
      key={link}
      url={link}
      styles={{ width: '100%', height: '900px' }}
    />
  );
}

CalendlyInline.propTypes = {
  link: PropTypes.string.isRequired,
};
